import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const t = l((e, a) => /* @__PURE__ */ s.jsx(
  o,
  {
    ref: a,
    ...e,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3520",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M15.22 12.57h-.55V6.68C14.68 3 11.67 0 7.98 0 4.33 0 1.35 2.95 1.29 6.59c0 .03-.01.07-.01.1v5.89H.75a.74.74 0 0 0-.75.74c0 .41.34.75.75.75h5.27c.03 1.06.9 1.91 1.96 1.91s1.93-.85 1.96-1.91h5.28a.749.749 0 1 0 0-1.5m-7.24 1.92c-.24 0-.43-.18-.46-.41h.92c-.03.23-.22.41-.46.41M2.79 6.78c0-.03.01-.06.01-.09 0-2.86 2.33-5.19 5.19-5.19 2.84 0 5.15 2.28 5.19 5.11v5.97H2.79z"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3520)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
t.displayName = "AgencyBellIcon";
export {
  t as AgencyBellIcon,
  t as default
};
//# sourceMappingURL=index.js.map
